import { UserDetails } from './user.model';

function normalizeImportedDate(value: unknown): unknown {
  if (typeof value !== 'string') {
    return value;
  }

  const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
  if (!match) {
    return value;
  }

  return `${match[1].padStart(2, '0')}/${match[2].padStart(2, '0')}/${match[3]}`;
}

export class UserSerialize {
  public static toUserDetails(userDetails: UserDetails): any {
    return {
      badge_number: userDetails.badgeNumber,
      firstName: userDetails.firstName,
      lastName: userDetails.lastName,
      email: userDetails.email,
      level: userDetails.level,
      role: userDetails.role?.toLowerCase(),
      title: userDetails.title,
      enabled: userDetails.enabled,
    };
  }

  public static toImportedUser(userDetails: any, header: string[]): any {
    return {
      title: userDetails[header[0]],
      badge_number: userDetails[header[1]],
      level: userDetails[header[2]],
      lastName: userDetails[header[3]],
      firstName: userDetails[header[4]],
      email: userDetails[header[5]],
      anzianitaPubblicaAmministrazione: normalizeImportedDate(
        userDetails[header[6]],
      ),
      anzianitaCategoriaAttuale: normalizeImportedDate(userDetails[header[7]]),
      anzianitaLivelloAttuale: normalizeImportedDate(userDetails[header[8]]),
      dataAssunzioneInEnac: normalizeImportedDate(userDetails[header[9]]),
    };
  }
}
